// extracted by mini-css-extract-plugin
export default {"vendor":"Vendor_vendor__3jBEj","vendorContainer":"Vendor_vendorContainer__eiBjH","header":"Vendor_header__YZgdG"};